'use strict'

import {INIT_COUNT_UP} from "../scripts/init.countup.js"
import Swiper from "swiper"
import {Navigation, Pagination} from "swiper/modules"

INIT_COUNT_UP()

const infoCardGallerySelector = '[data-swiper="border-box-gallery"]'
new Swiper(infoCardGallerySelector, {
  modules: [Navigation, Pagination],

  breakpoints: {
    320: {
      spaceBetween: 8,
      slidesPerView: 1.1
    },
    568: {
      spaceBetween: 16,
      slidesPerView: 1.5
    },
    992: {
      spaceBetween: 24,
      slidesPerView: 2.5
    },
  },

  pagination: {
    el: `${infoCardGallerySelector} + .row .swiper-pagination`,
    type: 'progressbar',
  },

  navigation: {
    nextEl: `${infoCardGallerySelector} + .row .swiper-button-next`,
    prevEl: `${infoCardGallerySelector} + .row .swiper-button-prev`,
  },
})
